import { useSelector } from 'react-redux';

import { getWorkspace, getWorkspaceMembersForWorkspace } from 'src/selectors/workspaces';
import { getCurrentUser } from 'src/selectors/currentUser';
import WorkspaceMember from 'src/entities/workspaceMember';
import User from 'src/entities/user';
import Workspace from 'src/entities/workspace';

interface UseWorkspaceSettingsProps {
	workspaceID: number;
}

const useWorkspaceSettings = ( { workspaceID }: UseWorkspaceSettingsProps ) => {
	// @ts-expect-error - TODO: fix this
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const workspace: Workspace = useSelector( ( state: any ) => getWorkspace( state, { workspaceID } ) );
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const currentUser: User = useSelector( ( state: any ) => getCurrentUser( state ) );
	const workspaceMembers: WorkspaceMember[] = useSelector(
		// @ts-expect-error - TODO: fix this
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		( state: any ) => getWorkspaceMembersForWorkspace( state, { workspaceID } )
	);

	const isOwner = workspace.userIsOwner( currentUser.id );
	const canTransferOwnership = workspace.canTransferOwnership( workspaceMembers );

	const canEditWorkspace = isOwner && workspace.isActive;
	const hideTransferOwnership = !workspace.hasSubscription;

	return {
		workspace,
		currentUser,
		workspaceMembers,
		isOwner,
		canTransferOwnership,
		canEditWorkspace,
		hideTransferOwnership
	};
};

export default useWorkspaceSettings;
